<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  export default {
    
  }
</script>

<style lang="less">
  body {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    color: #1f394d;
  }

  a {
    color: #4a8be9;
  }

</style>
